import { getElearningVideo } from 'src/common/services/elearning';
import { QueryKey } from 'src/config/queryKey';
import { useQuery } from 'react-query';
import { isNilEmpty } from 'src/lib/isNilEmpty';

export const useElearningVideoQuery = (id?: number) => {
  return useQuery([QueryKey.ElearningVideo, id], () => (id ? getElearningVideo(id) : undefined), {
    enabled: !isNilEmpty(id),
  });
};
